module.exports = __webpack_public_path__ + "static/media/RecomendaGoiania.98b71632.jpg";